import React from 'react';

function Sidebar() {
  const closeSidebar = () => {
    document.getElementById("mySidebar").style.display = "none";
    document.getElementById("myOverlay").style.display = "none";
  };

  const openSidebar = () => {
    document.getElementById("mySidebar").style.display = "block";
    document.getElementById("myOverlay").style.display = "block";
  }

  return (
    <>
      <nav className="w3-sidebar w3-black w3-collapse w3-top w3-large w3-padding" style={{ zIndex: 3, width: '300px', fontWeight: 'bold' }} id="mySidebar">
        <br />
        <button onClick={closeSidebar} className="w3-button w3-hide-large w3-display-topleft" style={{ width: '100%', fontSize: '22px' }}>Chiudi Menu</button>
        <div className="w3-container">
          <h3 className="w3-padding-64"><b>Nucifora Trasporti</b></h3>
        </div>
        <div className="w3-bar-block">
          <a href = "#home" onClick={closeSidebar} className="w3-bar-item w3-button w3-hover-amber w3-text-amber rounded">
            <i className="fas fa-home me-2"></i> Home
          </a>
          <a href="#who-i-am" onClick={closeSidebar} className="w3-bar-item w3-button w3-hover-amber w3-text-amber rounded">
            <i className="fas fa-users me-2"></i> Chi siamo
          </a>
          <a href="#services" onClick={closeSidebar} className="w3-bar-item w3-button w3-hover-amber w3-text-amber rounded">
            <i className="fas fa-cogs me-2"></i> Servizi
          </a>
          <a href="#gallery" onClick={closeSidebar} className="w3-bar-item w3-button w3-hover-amber w3-text-amber rounded">
            <i className="fas fa-images me-2"></i> Galleria
          </a>
          <a href="#contact" onClick={closeSidebar} className="w3-bar-item w3-button w3-hover-amber w3-text-amber rounded">
            <i className="fas fa-address-card me-2"></i> Contatti
          </a>

        </div>
      </nav>

      <header className="w3-container w3-top w3-hide-large w3-amber w3-xlarge w3-padding">
        <button className="w3-button w3-amber w3-margin-right" onClick={openSidebar}>☰</button>
        <span>Nucifora Trasporti</span>
      </header>
      <div className="w3-overlay w3-hide-large" onClick={closeSidebar} style={{ cursor: "pointer"}} title="Chiudi" id="myOverlay"></div>

    </>
  );
}

export default Sidebar;
